function loading(state = { isLoading : false }, action) {
    switch (action.type) {
      
      case "LOADING":
        return {
          ...state,
          isLoading: action.data
        };
          
      default:
        return state;
    }
  }
  
  export default loading;